import { render, staticRenderFns } from "./MoneyFormatter.vue?vue&type=template&id=49d03ee4"
import script from "./MoneyFormatter.vue?vue&type=script&lang=js"
export * from "./MoneyFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports